import { useMutation } from "@tanstack/react-query";
import api from "../api";
import useLocalSampleSummaryParams from "./useLocalSampleSummaryParams";

type LLMSummaryFeedbackParams = {
  isPositive: boolean;
  comment?: string;
};

const useLLMSummaryFeedback = () => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const {
    mutateAsync: postLLMSummaryFeedback,
    isError,
    error,
    isPending
  } = useMutation({
    mutationFn: ({ isPositive, comment }: LLMSummaryFeedbackParams) =>
      api.postLLMSummaryFeedback(
        hash ?? "",
        sourceId ?? 0,
        isPositive,
        relationshipId,
        comment
      )
  });

  return { postLLMSummaryFeedback, isError, error, isPending };
};

export default useLLMSummaryFeedback;
